import React, { useEffect, useMemo } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { useLocation } from 'react-router';
import { useSelector } from '../../redux/store';
import GameContainer from './GameContainer';
import { calculateFontSize } from '../../utils/formatString';
import { HEADER } from '../../config';

const supportedCategs = [
  'slots',
  'live-casino',
  'fishing',
  'card-game',
  'sports',
  'e-sports',
  'instant-game',
  'lottery',
];
const ProviderByCateg = () => {
  const { gameCategsAndCompanies } = useSelector((x) => x.lookup);

  const location = useLocation();

  const selectedCateg = useMemo(() => {
    if (location.state?.categ && supportedCategs.includes(location.state?.categ)) {
      const found = gameCategsAndCompanies.find((x) => x.slug === location.state.categ);
      if (found) return found;
    }

    return null;
  }, [gameCategsAndCompanies, location.state]);

  useEffect(() => {
    const scrollEl = document.getElementById('providers');
    if (scrollEl) {
      scrollEl.scrollIntoView();
    }
  }, [location.state?.categ]);

  return (
    <Box sx={{ scrollMarginTop: HEADER.MOBILE_HEIGHT, p: '0.5rem' }} id="providers">
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
        <Typography fontWeight={900}>{selectedCateg?.name}</Typography>
      </Box>

      {selectedCateg ? (
        <Grid container spacing={2}>
          {selectedCateg?.companies.map((g, gIndex) => (
            <Grid key={gIndex} item xl={3} lg={3} md={4} sm={6} xs={6}>
              <GameContainer
                item={g}
                companySlug={location.state.categ}
                // containerSx={{
                //   background:
                //     'linear-gradient(0deg, rgba(1,161,1,1) 0%, rgba(1,161,1,1) 90%, rgba(178,255,1,1) 100%)',
                // }}
                // imgWrapperSx={{ width: '100px', minHeight: '140px' }}
                titleSx={{ fontSize: calculateFontSize(g?.name, 14, 18) }}
                hasShadow
                isProvider
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        ''
      )}
    </Box>
  );
};

export default ProviderByCateg;
